import { HighDemandIcon, TopRatingIcon, TrendingIcon } from "../icons";

export const filterTypeOptions = {
    string: "string",
    selection: "selection",
    number: "number",
    numberRange: "numberRange",
    boolean: "boolean",
    toogleType: "toogle",
    dateRange: "dateRange"
}

export const tagOptions = [
    { label: 'Trending', value: 'trending', icon: <TrendingIcon fontSize="small" /> },
    { label: 'Top Rated', value: 'topRated', icon: <TopRatingIcon fontSize="small" /> },
    { label: 'High Demand', value: 'highDemand', icon: <HighDemandIcon fontSize="small" /> },
    { label: 'Uncategorized', value: 'uncategorized', icon: <HighDemandIcon fontSize="small" /> },
]

export const enrollmentOptions = [
    { label: 'Admission Open', value: 'admissionOpen', color: '#22c55e' },
    { label: 'Few Seats Left', value: 'fewSeatsLeft', color: '#8b5cf6' },
    { label: 'Closes Soon', value: 'closesSoon', color: '#f97316' },
    { label: 'Closed', value: 'closed', color: '#ef4444' },
    { label: 'Uncategorized', value: 'uncategorized', color: '#44c7efff' },
];

export const studentStatusList = [
    { label: "Approved", value: "approved" },
    { label: "Pending", value: "pending" },
    { label: "Re-sumbitted", value: "re-sumbitted" },
    { label: "Rework", value: "rework" },
    { label: "Draft", value: "draft" },
]

export const reviewerStatusList = [
    { label: "Approved", value: "approved" },
    { label: "Pending", value: "pending" },
    { label: "Re-Submitted", value: "re-submitted" },
    { label: "Send for Rework", value: "rework" },
]

export const callStatusList = [
    { label: "Completed", value: "completed" },
    { label: "Scheduled", value: "scheduled" },
    { label: "Pending", value: "pending" },
    { label: "Cancelled", value: "cancelled" },
]

export const reviewStatusList = [
    { label: "Pending", value: "pending" },
    { label: "Approved", value: "approved" },
    { label: "Rejected", value: "rejected" },
]

export const normalStatusList = [
    { label: "Live", value: "live" },
    { label: "Deactivated", value: "deactivated" },
]

export const webLeadsStatusList = [
    { label: 'Pending', value: 'pending' },
    { label: 'Interested', value: 'interested' },
    { label: 'Call back request', value: 'call_back_request' },
    { label: 'Not Interested', value: 'not_interested' },
    { label: 'Not Eligible', value: 'not_eligible' },
    { label: 'Prospect for next session', value: 'prospect_for_next_session' },
    { label: 'Registration Done', value: 'registration_done' },
    { label: 'Paid', value: 'paid' },
];

export const paymentStatusList = [
    { label: "Partial", value: "partial" },
    { label: "EMI", value: "emi" },
    { label: "Full", value: "full" },
]

export const currentyList = [
    { label: "INR", value: "inr" },
    { label: "USD", value: "usd" },
]

export const paymentRequestStatusList = [
    { label: "Succeeded", value: "succeeded" },
    { label: "Pending", value: "pending" },
    { label: "Failed", value: "failed" },
]

export const creditTypeList =  [
    { label: "Bank Transfer", value: "bank" },
]


export const universityTypeList = [
    { label: "Govt University", value: "Govt University" },
    { label: "Private University", value: "Private University" },
    { label: "Deemed University", value: "Deemed University" },
    { label: "State University", value: "State University" },
]

export const toogleOptions = [
    { label: "Active", value: true },
    { label: "Deactive", value: false },
]

export const defaultPaginationValues = {page:0,pageSize:50}